export default __webpack_public_path__ + "media/images/5-701253b0bc808e9aefa009f65706134b.jpg";